import React from 'react';
import * as S from './WhyMypartner.styles';
import IconSelector from '@ibibo/icon-selector';

const WhyMypartner = () => {
    return(
        <S.WhyMyPartnerMainWrap>
            <S.WhyMypartnerOuterWrap>
                <S.WhyMypartnerInnerWrap>
                    <S.WhyMypartnerHeadWrap>
                        <S.WhyMypartnerHeadText>Why myPartner?</S.WhyMypartnerHeadText>
                        <S.WhyMypartnerSubText>Join us to discover the smart way to grow your business</S.WhyMypartnerSubText>
                    </S.WhyMypartnerHeadWrap>   
                    <S.WhyMyPartnerBenifitWrap>
                        <S.BenifitInnerWrap>
                            <S.BenifitCardWrap>
                                <S.BenifitIconWrap>
                                    <IconSelector iconKey='bastRates' />
                                </S.BenifitIconWrap>
                                <S.BenifitTextWrap>
                                    <S.BenifitHeadText>BEST EVER RATES</S.BenifitHeadText>
                                    <S.BenifitSubText>Exclusive rates for our partners</S.BenifitSubText>
                                </S.BenifitTextWrap>
                            </S.BenifitCardWrap>
                            <S.BenifitCardWrap>
                                <S.BenifitIconWrap>
                                    <IconSelector iconKey='widestInventory' />
                                </S.BenifitIconWrap>
                                <S.BenifitTextWrap>
                                    <S.BenifitHeadText>WIDEST INVENTORY</S.BenifitHeadText>
                                    <S.BenifitSubText>300+ Airline Carriers | 8 lac+ Hotel Properties</S.BenifitSubText>
                                </S.BenifitTextWrap>
                            </S.BenifitCardWrap>
                        </S.BenifitInnerWrap>
                        <S.BenifitInnerWrap>
                            <S.BenifitCardWrap>
                                <S.BenifitIconWrap>
                                    <IconSelector iconKey='neverBefore' />
                                </S.BenifitIconWrap>
                                <S.BenifitTextWrap>
                                    <S.BenifitHeadText>Never before deals</S.BenifitHeadText>
                                    <S.BenifitSubText>Access to the best deals</S.BenifitSubText>
                                </S.BenifitTextWrap>
                            </S.BenifitCardWrap>
                            <S.BenifitCardWrap>
                                <S.BenifitIconWrap>
                                    <IconSelector iconKey='expressCare' />
                                </S.BenifitIconWrap>
                                <S.BenifitTextWrap>
                                    <S.BenifitHeadText>Express Care</S.BenifitHeadText>
                                    <S.BenifitSubText>Easy-to-use tools for query resolutions</S.BenifitSubText>
                                </S.BenifitTextWrap>
                            </S.BenifitCardWrap>
                        </S.BenifitInnerWrap>
                        <S.BenifitInnerWrap>
                            <S.BenifitCardWrap>
                                <S.BenifitIconWrap>
                                    <IconSelector iconKey='confidential' />
                                </S.BenifitIconWrap>
                                <S.BenifitTextWrap>
                                    <S.BenifitHeadText>CONFIDENTIALITY ASSURED</S.BenifitHeadText>
                                    <S.BenifitSubText>Complete confidentiality of your customer details & bookings</S.BenifitSubText>
                                </S.BenifitTextWrap>
                            </S.BenifitCardWrap>
                        </S.BenifitInnerWrap>
                    </S.WhyMyPartnerBenifitWrap>
                </S.WhyMypartnerInnerWrap>
            </S.WhyMypartnerOuterWrap>
        </S.WhyMyPartnerMainWrap>
    )
}

export default WhyMypartner;